import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import logoImg from '../assets/blast-logo.webp';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:3301/api';

export default function GalleryDetail() {
  const { albumId } = useParams();
  const [photos, setPhotos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [previewPhoto, setPreviewPhoto] = useState(null);

  useEffect(() => {
    axios.get(`${API_BASE}/gallery/${albumId}/photos`)
      .then((res) => setPhotos(res.data))
      .catch((err) => console.error(err))
      .finally(() => setLoading(false));
  }, [albumId]);

  return (
    <div style={{ background: '#12151A', color: '#F0EDE4', minHeight: '100vh', fontFamily: "'Segoe UI', sans-serif" }}>
      <nav style={{ padding: '18px 6vw', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <img src={logoImg} alt="Blast Motor Club" style={{ height: 36, width: 'auto' }} />
        <Link to="/" style={{ color: '#D02127', fontSize: 13, textDecoration: 'none' }}>← Beranda</Link>
      </nav>

      <div style={{ padding: '0 6vw 60px', maxWidth: 900, margin: '0 auto' }}>
        <h1 style={{ fontSize: 'clamp(24px, 4vw, 36px)', fontWeight: 900, fontStyle: 'italic', margin: '6px 0 24px' }}>
          Galeri Foto
        </h1>

        {loading ? (
          <p style={{ color: '#8B92A0' }}>Memuat foto...</p>
        ) : photos.length === 0 ? (
          <p style={{ color: '#8B92A0' }}>Belum ada foto di album ini.</p>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(140px, 1fr))', gap: 12 }}>
            {photos.map((p) => (
              <div
                key={p.id}
                onClick={() => setPreviewPhoto(p.id)}
                style={{ position: 'relative', aspectRatio: '1', borderRadius: 8, overflow: 'hidden', background: '#1C2128', cursor: 'pointer' }}
              >
                <img src={p.photo_url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              </div>
            ))}
          </div>
        )}
      </div>

      {previewPhoto && (
        <div
          onClick={() => setPreviewPhoto(null)}
          style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.9)', zIndex: 100,
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 20,
          }}
        >
          <img
            src={photos.find((p) => p.id === previewPhoto)?.photo_url}
            alt=""
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: '100%', maxHeight: '75vh', borderRadius: 8, objectFit: 'contain' }}
          />
          <div style={{ display: 'flex', gap: 12, marginTop: 20 }} onClick={(e) => e.stopPropagation()}>
            <a
              href={`${API_BASE}/gallery/photo/${previewPhoto}/download`}
              style={{ background: '#D02127', color: '#fff', padding: '10px 22px', borderRadius: 6, fontSize: 14, fontWeight: 700, textDecoration: 'none' }}
            >
              ⬇ Unduh
            </a>
            <button
              onClick={() => setPreviewPhoto(null)}
              style={{ background: 'transparent', border: '1px solid #262b33', color: '#F0EDE4', padding: '10px 22px', borderRadius: 6, fontSize: 14, cursor: 'pointer' }}
            >
              Tutup
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
